var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"md6":""}},[_c('RequestedBoletosList')],1),_c('v-col',{attrs:{"md6":""}},[_c('BoletoInfoTab')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }